
























import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import ResetPasswordForm from "@/components/authentication/ResetPasswordForm.vue";

@Component({
  components: {
    ResetPasswordForm
  }
})
export default class ResetPasswordPage extends Vue {
  @Prop([String])
  public token: string;

  @Prop([String])
  public emailaddress: string;
}
